import React from 'react'
import { Link as RouterLink } from 'react-router-dom'
import { reverse } from 'named-urls'
import PropTypes from 'prop-types'
import { Box, Link, Typography } from '@material-ui/core'
import { FileText as FileTextIcon } from 'react-feather'

import { routes } from 'Routes'

const MessageLinkedDocumentTemplate = ({ documentTemplate }) => {
  return (
    <Link
      component={RouterLink}
      to={reverse(routes.documents.generate, {
        documentTemplateId: documentTemplate.id,
      })}
      color="secondary"
    >
      <Box display="flex" alignItems="center" gridGap={4}>
        <FileTextIcon size={18} />
        <Typography variant="body2" noWrap>
          {documentTemplate.name}
        </Typography>
      </Box>
    </Link>
  )
}

MessageLinkedDocumentTemplate.propTypes = {
  documentTemplate: PropTypes.shape({
    id: PropTypes.number.isRequired,
    name: PropTypes.string.isRequired,
  }).isRequired,
}

export default MessageLinkedDocumentTemplate
